export default "__VITE_PUBLIC_ASSET__dfa8046c__"